var render = function () {
  var _vm$currentRound$hear, _vm$currentRound$hear2, _vm$currentRound$hear3, _vm$currentRound$hear4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "hearittypeit-container"
  }, [_c('div', {
    staticClass: "hit-instructions"
  }, [_c('audio-toggle-button'), _c('h1', [_vm._v(_vm._s(_vm.currentRound.instructions))])], 1), _vm.showContent ? _c('div', {
    staticClass: "content",
    attrs: {
      "transition": "fade-05"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm.currentRound.hearItTypeItImage ? _c('img', {
    attrs: {
      "src": (_vm$currentRound$hear = _vm.currentRound.hearItTypeItImage) === null || _vm$currentRound$hear === void 0 ? void 0 : (_vm$currentRound$hear2 = _vm$currentRound$hear.image) === null || _vm$currentRound$hear2 === void 0 ? void 0 : _vm$currentRound$hear2.src,
      "alt": (_vm$currentRound$hear3 = _vm.currentRound.hearItTypeItImage) === null || _vm$currentRound$hear3 === void 0 ? void 0 : (_vm$currentRound$hear4 = _vm$currentRound$hear3.image) === null || _vm$currentRound$hear4 === void 0 ? void 0 : _vm$currentRound$hear4.description
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "right"
  }, [_vm._l(_vm.attempts, function (attempt, idx) {
    var _vm$currentRound;
    return _c('div', {
      key: attempt.key,
      staticClass: "attempt"
    }, [idx < _vm.attempts.length - 1 && (attempt.blinking || attempt.isCompleted) ? _c('div', {
      staticClass: "attempt-line",
      attrs: {
        "id": ("attempt-" + idx),
        "transition": _vm.transition
      }
    }, [_c('div', {
      staticClass: "attempt-box focusable",
      attrs: {
        "role": "textbox",
        "tabindex": "0"
      }
    }, [_c('div', {
      staticClass: "box-wrapper"
    }, [_c('p', {
      class: ['box-text', {
        blinking: attempt.blinking
      }]
    }, _vm._l(attempt.text, function (letter, jdx) {
      return _c('span', {
        key: jdx + letter,
        attrs: {
          "aria-hidden": "true"
        }
      }, [_vm._v(_vm._s(letter === ' ' ? ' ' : letter))]);
    }), 0)])]), attempt.text && attempt.text.length > 0 ? _c('done-button', {
      class: [attempt.blinking ? '' : 'hidden'],
      attrs: {
        "on-click": _vm.onDone,
        "transition": _vm.innerTransition,
        "text": "Done"
      }
    }) : _vm._e()], 1) : _vm._e(), idx === _vm.attempts.length - 1 && (attempt.blinking || attempt.isCompleted) ? _c('div', {
      attrs: {
        "transition": _vm.transition
      }
    }, [_c('div', {
      staticClass: "attempt-box blinking-text"
    }, [_c('blinking-cursor-text', {
      attrs: {
        "round-id": _vm.progress.roundIndex,
        "class-name": 'box-text',
        "text": (_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : _vm$currentRound.answer,
        "text-step": 0
      }
    })], 1)]) : _vm._e()]);
  }), _vm.showBox ? _c('div', {
    staticClass: "did-you-hear-box",
    attrs: {
      "transition": _vm.transition
    },
    on: {
      "transitionend": _vm.onTryEnd
    }
  }, [_c('div', {
    staticClass: "hear-text"
  }, [_c('p', {
    staticClass: "hear-text"
  }, [_vm._v("\n                  " + _vm._s(_vm.hearText) + "\n                ")])]), _c('img', {
    attrs: {
      "src": _vm.didYouHear,
      "alt": "Did you hear"
    }
  })]) : _vm._e(), _vm.tryAgain ? _c('div', {
    attrs: {
      "transition": _vm.innerTransition,
      "aria-live": "assertive",
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "try-again",
    on: {
      "click": _vm.onTryAgain
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.tryAgainButton,
      "alt": ""
    }
  }), _c('span', [_vm._v("Try Again")])])]) : _vm._e()], 2)]) : _vm._e()])])]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }